import React from 'react'
import { useResponsive } from '../../../../../../components/src/hooks'
import { DesktopScreen } from './DesktopScreen'
import { MobileScreen } from './MobileScreen'

export const SelectProject = (props) => {
  const { sm } = useResponsive()

  return sm ? <DesktopScreen {...props} /> : <MobileScreen {...props} />
}
